import { CubePresenter, Logger, NOOP_VOID } from 'wdc-cube';
import { AppDeleteAccountKeys } from './app-delete-account.key';
import { AppDeleteAccountScope } from './app-delete-account.scope';
const LOG = Logger.get('Mormaii.AppDeleteAccountPresenter');
/**
 * O passo a passo, LITERALMENTE como o painel antigo o escreve.
 *
 * A exclusao acontece no APP, nao aqui: esta pagina existe para as lojas terem um
 * endereco publico que a explique, e mudar o texto sem mudar o app seria mentir
 * sobre o caminho.
 *
 * O texto e o de la, com os deslizes corrigidos NOS DOIS paineis - virgula
 * dobrada, "email", "sera" sem acento e a concordancia de "apresentado".
 * Corrigir so aqui abriria divergencia de paridade; por isso a mesma correcao
 * foi para o `frontend-web`.
 */
const STEPS = [
    'Abra o app.',
    'Realize o login (e-mail e senha).',
    'Na barra inferior, clicar em Meus dados.',
    'Na página Meus dados, clicar em Excluir conta.',
    'Ao clicar em excluir conta, irá abrir um pop up para confirmação da exclusão (ação irreversível).',
    'Clicar em Sim, excluir.',
    'Após a ação será apresentada uma mensagem de sucesso.'
];
export class AppDeleteAccountPresenter extends CubePresenter {
    constructor(app) {
        super(app, new AppDeleteAccountScope());
        this.parentSlot = NOOP_VOID;
    }
    release() {
        super.release();
        LOG.info('Finalized');
    }
    async applyParameters(intent, initialization) {
        const keys = new AppDeleteAccountKeys(this.app, intent);
        if (initialization) {
            this.scope.steps = [...STEPS];
            LOG.info('Initialized');
        }
        // O slot e decidido acima na composicao e pode mudar entre viagens: le-se sempre.
        this.parentSlot = keys.parentSlot;
        this.parentSlot(this.scope);
        return true;
    }
}
//# sourceMappingURL=app-delete-account.presenter.js.map